/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button, TextField, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import {
    AddNewClientSiteContacts,
    deleteClientSiteContact,
    editClientSiteContact,
    getAllClientSiteContacts
} from "../../../api/apiCall";
import { useAuth } from "../../../auth/auth";
import { format } from "date-fns";
import { toast } from "react-toastify";
import { Modal } from "antd";

const ClientSiteContact = () => {
    const {state} = useAuth();
    const [clientSiteContacts, setClientSiteContacts] = useState<any>([]);
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [modalMode, setModalMode] = useState<'add' | 'edit'>('add');
    const [currentContact, setCurrentContact] = useState<any>(null);
    const [contactName, setContactName] = useState('');
    const [formError, setFormError] = useState('');
    const [, setOpen] = useState(false);

    const handleAddClick = () => {
        setModalMode('add');
        setContactName('');
        setCurrentContact(null);
        setFormError('');
        setIsDialogOpen(true);
    };

    const handleEditClick = (params: any) => {
        setModalMode('edit');
        setCurrentContact(params.row);
        setContactName(params.row.clientContact);
        setFormError('');
        setIsDialogOpen(true);
    };

    const handleDialogClose = () => {
        setIsDialogOpen(false);
        setContactName('');
        setCurrentContact(null);
        setFormError('');
    };

    const handleSubmit = async () => {
        if (!contactName.trim()) {
            setFormError('Client Site Contact cannot be empty');
            return;
        }

        if (modalMode === 'add') {
            const response = await AddNewClientSiteContacts(state.user?.token, contactName);
            if (response) {
                toast.success(response.data);
                getAllClientSiteContacts(state.user?.token).then(setClientSiteContacts);
                handleDialogClose();
            } else {
                toast.error('Something went wrong!');
            }
        } else {
            if (currentContact) {
                const response = await editClientSiteContact(state.user?.token, currentContact.id, contactName);
                if (response) {
                    toast.success(response.data);
                    getAllClientSiteContacts(state.user?.token).then(setClientSiteContacts);
                    handleDialogClose();
                } else {
                    toast.error('Something went wrong!');
                }
            }
        }
    };

    const handleDelete = async (id: any) => {
        const response = await deleteClientSiteContact(state.user?.token, id);
        if(response) {
            toast.success(response.data)
            getAllClientSiteContacts(state.user?.token).then(setClientSiteContacts);
        } else {
            toast.error('Something went wrong!')
        }
    }

    const columns: any = [
        {
            field: "clientContact",
            headerName: "Client Site Contact",
            flex: 1,
            renderCell: (params: any) => (
                <div>{params.row.clientContact}</div>
            ),
        },
        {
            field: "createdDate",
            headerName: "Created Date",
            flex: 0.3,
            renderCell: (params: any) => (
                <div>
                    {format(new Date(params.row.createdDate || Date.now()), 'dd/MM/yyyy')}
                </div>
            ),
        },
        {
            field: "actions",
            headerName: "Actions",
            flex: 0.5,
            headerAlign: "center",
            align: "center",
            renderCell: (params: any) => (
                <div>
                    <Button 
                        color="primary"
                        variant="contained" 
                        onClick={() => handleEditClick(params)}
                        size="small"
                        style={{ marginRight: 8, backgroundColor: "#6c757d", boxShadow: "none" }}
                    >
                        Edit
                    </Button>  
                    <Button 
                        color="error" 
                        variant="contained"
                        size="small"
                        style={{boxShadow: "none"}}
                        onClick={() => {
                            setOpen(true);
                            Modal.confirm({
                                title: 'Are you sure you want to delete this Client Site Contact?',
                                onOk: () => handleDelete(params.id),
                                okButtonProps: { danger: true },
                                okText: 'YES',
                                cancelText: 'NO',
                                centered: true
                            });
                        }}
                    >
                        Delete
                    </Button>
                </div>
            )
        }
    ];

    useEffect(() => {
        getAllClientSiteContacts(state.user?.token).then(setClientSiteContacts);
    }, []);

    return (
        <Box 
            sx={{
                p: 3,
                borderRadius: '16px',
                backgroundColor: '#ffffff',
                maxWidth: '1200px',
                margin: '0 auto'
            }}>
            <Box
                sx={{ 
                    display: 'flex', 
                    justifyContent: 'flex-end', 
                    alignItems: 'center',
                    m: 3,
                }}
            >
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleAddClick}  
                    style={{boxShadow: 'none'}}
                >
                    Add Client Site Contact
                </Button>
            </Box>
            <Box 
                sx={{
                    margin: '0 auto',
                    height: '735px',
                    "@media (max-width: 900px)": {
                        overflowX: "auto",
                        margin: 1,
                        minWidth: "95%",
                    },
                }}>
                <DataGrid
                    rows={clientSiteContacts}
                    columns={columns}
                    disableRowSelectionOnClick
                    sx={{
                        "@media (max-width: 700px)": {
                            minWidth: "100%",
                        },
                        "& .MuiDataGrid-columnHeader": {
                            color: "#333",
                            fontWeight: "bold",
                            fontSize: 15,
                            backgroundColor: '#f0f0f0',
                        },
                        "& .MuiDataGrid-columnHeaderTitle": {
                            fontWeight: "bold",
                        },
                        "@media (max-width: 600px)": {
                            fontSize: "0.7rem",
                        },
                    }}
                />
            </Box>

            <Dialog 
                open={isDialogOpen} 
                onClose={handleDialogClose}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>
                    {modalMode === 'add' ? 'Add New Client Site Contact' : 'Edit Client Site Contact'}
                </DialogTitle>
                <DialogContent>
                    <TextField
                        size="small"
                        autoFocus
                        margin="dense"
                        label="Client Site Contact"
                        type="text"
                        fullWidth
                        variant="outlined"
                        value={contactName}
                        onChange={(e) => {
                            setContactName(e.target.value);
                            setFormError('');
                        }}
                        error={!!formError}
                        helperText={formError}
                        onKeyPress={(e) => {
                            if (e.key === 'Enter') {
                                handleSubmit();
                            }
                        }}
                        sx={{ mt: 2 }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDialogClose} color="inherit">
                        Cancel
                    </Button>
                    <Button onClick={handleSubmit} color="primary" variant="contained" style={{boxShadow: 'none'}}>
                        {modalMode === 'add' ? 'Add' : 'Save'}
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default ClientSiteContact;
